import { AreasState, State } from '../configure-store';
import { Scope } from '../../types/roles';

export const getAreas = (state: State): AreasState => state.areas;

export const getAllScopes = (state: State): Scope[] => {
  const areas = getAreas(state);
  return areas.map(area => area.scopes).flat();
};

export const getScope = (state: State, scopeId: string): Scope => getAllScopes(state)?.find(scope => scope.id === scopeId);

export const getScopeSelectedDependencies = (state: State, selectedScopes: string[], scopeId: string): Scope[] =>
  getAllScopes(state).filter(scope => scope.dependantScopes.includes(scopeId) && selectedScopes.includes(scope.id));
